import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  PencilSquareIcon,
  TrashIcon,
  BarsArrowUpIcon,
  BarsArrowDownIcon,
} from "@heroicons/react/24/outline";

import { toast } from "react-toastify";
import {
  deleteCategory,
  fetchCategoryByType,
  fetchCategoryByTypePublic,
} from "../../features/admin/CategorySlice";
import { fetchPermissionsCate } from "../../features/admin/RoleSlice";
import CategoryModal from "../../components/admin/CategoryModal";
import ApiCustom from "../../utils/ApiCustom";
import TableComponent from "../../components/TableComponent";
import ConfirmDeleteModal from "../../components/ConfirmDeleteModal";

const activeReorderList = [
  "navbar",
  "training_recruitment",
  "practice_certificate",
  "legal_document",
  "cadoor",
];

const getUserPermissions = () => {
  const permissions = localStorage.getItem("permissions");
  return permissions
    ? JSON.parse(permissions).map((p) => p.permissionSlug)
    : [];
};

const userId = localStorage.getItem("userId");
const hasPermission = (requiredPermission) => {
  if (userId == 1) {
    return true;
  }
  const userPermissions = getUserPermissions();
  return userPermissions.includes(requiredPermission);
};

const Category = () => {
  const dispatch = useDispatch();
  const { categories, status, error } = useSelector(
    (state) => state.categories,
  );
  const [deleteId, setDeleteId] = useState(null);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [triggerUpdateOrder, setTriggerUpdateOrder] = useState(false);
  const handleOpenDeleteModal = (id) => {
    setDeleteId(id);
    setIsDeleteOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteId(null);
    setIsDeleteOpen(false);
  };
  const tabData = [
    { value: "category", title: "Sản phẩm" },
    { value: "post", title: "Bài viết" },
    { value: "company", title: "Lĩnh vực" },
    { value: "navbar", title: "Hoạt động" },
    { value: "training_recruitment", title: "Đào tạo & tuyển dụng" },
    { value: "practice_certificate", title: "Cấp chứng chỉ" },
    { value: "legal_document", title: "Văn bản pháp luật" },
    { value: "cadoor", title: "Chi hội Cadoor" },
    { value: "notification", title: "Đăng ký hoạt động" },
  ];
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentCategory, setCurrentCategory] = useState(null);
  const [activeTab, setActiveTab] = useState("category");
  const userId = localStorage.getItem("userId");
  useEffect(() => {
    dispatch(fetchPermissionsCate());
  }, [triggerUpdateOrder]);
  useEffect(() => {
    if (status === "idle") {
      if (userId == 1) {
        dispatch(fetchCategoryByTypePublic(activeTab));
      } else {
        dispatch(fetchCategoryByType(activeTab));
      }
      dispatch(fetchPermissionsCate());
    }
  }, [status, dispatch, activeTab, triggerUpdateOrder]);

  useEffect(() => {
    if (userId == 1) {
      dispatch(fetchCategoryByTypePublic(activeTab));
    } else {
      dispatch(fetchCategoryByType(activeTab));
    }
  }, [activeTab, dispatch, triggerUpdateOrder]);

  const handleOpenModal = (category) => {
    if (category?.id) getCategoryByid(category?.id);
    else setIsModalOpen(true);
  };

  const getCategoryByid = (id) => {
    ApiCustom.get(`categories/${id}`)
      .then((res) => {
        setCurrentCategory(res.data.data?.data);
        setIsModalOpen(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setCurrentCategory(null);
  };

  const handleDelete = () => {
    dispatch(deleteCategory(deleteId)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        handleCloseDeleteModal();
        toast.success("Xóa danh mục thành công!");
      } else {
        toast.error("Đã xảy ra lỗi khi xóa danh mục!");
      }
    });
  };

  const handlePriorityChange = (type, cateId, changeType) => {
    ApiCustom.put(`/categories-change-priority/`, {
      id: cateId,
      type: type,
      changeType: changeType,
    })
      .then(() => {
        setTriggerUpdateOrder(!triggerUpdateOrder);
      })
      .catch((error) => {
        console.log(error);
        if (error.response?.status === 422) {
          toast.error(Object.values(error.response?.data?.messages)[0]);
        }
      });
  };

  if (status === "loading") return <p>Loading...</p>;
  if (status === "failed") return <p>Error: {error}</p>;

  // const renderRow = (category, isChild = false) => (
  //   <tr key={category.id} className={isChild ? "bg-gray-50" : "bg-white"}>
  //     <td className={`border px-4 py-2 ${isChild ? "pl-8" : ""}`}>
  //       {category.name}
  //     </td>
  //     <td className="border px-4 py-2">{category.description}</td>
  //     <td className="border px-4 py-2">
  //       <div className="flex space-x-2">
  //         {hasPermission("CATEGORY_UPDATE") && (
  //           <button
  //             onClick={() => handleOpenModal(category)}
  //             className="btn btn-outline btn-warning btn-sm px-3 my-1 rounded"
  //           >
  //             <PencilSquareIcon className="w-5 h-5" />
  //           </button>
  //         )}
  //         {hasPermission("CATEGORY_DELETE") && (
  //           <button
  //             onClick={() => handleOpenDeleteModal(category.id)}
  //             className="btn btn-outline btn-error btn-sm px-3 my-1 rounded"
  //           >
  //             <TrashIcon className="w-5 h-5" />
  //           </button>
  //         )}
  //       </div>
  //     </td>
  //   </tr>
  // );

  // Nếu activeTab === "navbar" thì nhóm danh mục theo parentId
  // const groupedCategories =
  //   activeTab === "navbar"
  //     ? categories.reduce((acc, cat) => {
  //         if (cat.parentId === null) {
  //           acc[cat.id] = { ...cat, children: [] };
  //         } else {
  //           if (acc[cat.parentId]) {
  //             acc[cat.parentId]?.child?.push(cat);
  //           } else {
  //             acc[cat.parentId] = { children: [cat] };
  //           }
  //         }
  //         return acc;
  //       }, {})
  //     : null;

  const headers = [
    {
      key: "id",
      label: "STT",
      render: (_, index) => {
        return <span>{index + 1}</span>;
      },
    },
    { key: "name", label: "Tên" },
    { key: "description", label: "Mô tả" },
    {
      key: "isComment",
      label: "Góp ý",
      visible: (item) =>
        item.type == "navbar" ||
        item.type == "post" ||
        item.type == "training_recruitment" ||
        item.type == "practice_certificate" ||
        item.type == "legal_document" ||
        item.type == "cadoor",
      render: (item) => (
        <span
          className={`px-3 py-1 rounded-full text-sm ${
            item.isComment
              ? "bg-green-100 text-green-800"
              : "bg-red-100 text-red-800"
          } whitespace-nowrap`}
        >
          {item.isComment ? "Có" : "Không"}
        </span>
      ),
    },
  ];

  if (hasPermission("CATEGORY_UPDATE") || hasPermission("CATEGORY_DELETE")) {
    headers.push({ key: "setting", label: "Phương thức" });
  }

  const tableSettings = {
    renderSettings: (item, index) => (
      <div className="flex space-x-2">
        {hasPermission("CATEGORY_UPDATE") && (
          <button
            onClick={() => handleOpenModal(item)}
            className="btn btn-outline btn-warning btn-sm px-3 my-1 rounded"
          >
            <PencilSquareIcon className="w-5 h-5" />
          </button>
        )}
        {hasPermission("CATEGORY_DELETE") && (
          <button
            // onClick={() => handleDelete(item.id)}
            onClick={() => handleOpenDeleteModal(item.id)}
            className="btn btn-outline btn-error btn-sm px-3 my-1 rounded"
          >
            <TrashIcon className="w-5 h-5" />
          </button>
        )}

        {hasPermission("CATEGORY_UPDATE") &&
          activeReorderList.includes(activeTab) && (
            <>
              <button
                title="Di chuyển lên"
                disabled={index === 0}
                onClick={() => {
                  handlePriorityChange(activeTab, item.id, "up");
                }}
                className="btn btn-outline btn-info btn-sm px-3 my-1 rounded"
              >
                <BarsArrowUpIcon className="w-5 h-5" />
              </button>

              <button
                title="Di chuyển xuống"
                disabled={index >= categories.length - 1}
                onClick={() => {
                  handlePriorityChange(activeTab, item.id, "down");
                }}
                className="btn btn-outline btn-info btn-sm px-3 my-1 rounded"
              >
                <BarsArrowDownIcon className="w-5 h-5" />
              </button>
            </>
          )}
      </div>
    ),
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Quản lý danh mục</h1>
      {hasPermission("CATEGORY_CREATE") && (
        <button
          onClick={() => handleOpenModal()}
          className="btn btn-success transition-colors px-4 py-2 rounded mb-4"
        >
          + Thêm danh mục
        </button>
      )}
      <div className="tabs mb-2">
        {tabData.map((tab) => (
          <button
            key={tab.value}
            onClick={() => setActiveTab(tab.value)}
            className={`tab ${
              activeTab === tab.value ? "tab-active" : ""
            } tab-lifted`}
          >
            {tab.title}
          </button>
        ))}
      </div>

      <div className="rounded-lg shadow">
        <TableComponent
          headers={headers}
          data={categories}
          settings={tableSettings}
          contentHeight="62.7vh"
        />
      </div>

      {isModalOpen && (
        <CategoryModal
          onClose={handleCloseModal}
          category={currentCategory}
          types={tabData}
          isOpen={isModalOpen}
          tab={activeTab}
        />
      )}
      <ConfirmDeleteModal
        isOpen={isDeleteOpen}
        onClose={handleCloseDeleteModal}
        onConfirm={handleDelete}
      />
    </div>
  );
};

export default Category;